import React from 'react';
import { PercentIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { breakpoints } from '../../../../../../media';

const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	max-width: max-content;
	padding: 4px;
	margin-top: 12px;
	column-gap: 0;
	background-color: var(--service-light);
	border: 1px solid var(--service-primary);
	border-radius: 8px;

	${breakpoints.only.mobile} {
		margin-top: 8px;
	}
`;

const textStyles = css`
	padding: 4px;
`;
const IconWrapper = styled.div`
	padding: 4px;
`;

const icon = css`
	& path:first-child {
		opacity: 0.2;
		fill: var(--service-primary);
	}

	& path:nth-child(2) {
		stroke: var(--service-primary);
		stroke-width: 1.25;
	}

	& path:nth-child(3) {
		stroke: var(--service-primary);
		stroke-width: 1.25;
	}
`;

export const CompensationAlert = () => (
	<Wrapper>
		<IconWrapper>
			<PercentIcon type="duotone" size="l" className={icon} />
		</IconWrapper>
		<Typography variant="caption" className={textStyles}>
			Компенсируем стоимость замера при заказе установки в&nbsp;магазине
		</Typography>
	</Wrapper>
);
